import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { HighlightSnippet } from '../../../helpers/formattingHelper';
import { FaqsQuestionPropTypes } from '../../../propTypes/faqs';

export const HelpTopicSearchResultLabel = ({ topicDetail, highlightText }) => {
  const { question, answer, tags } = topicDetail;

  const summaryMarkup = useMemo(() => {
    // Take a snippet from the answer containing the search term
    return (
      <span className="topicSummary">
        {HighlightSnippet({
          textString: answer,
          highlightString: highlightText
        })}
      </span>
    );
  }, [highlightText, answer]);

  const headingMarkup = useMemo(() => {
    return (
      <strong className="topicHeading">
        {HighlightSnippet({
          textString: question,
          highlightString: highlightText
        })}
      </strong>
    );
  }, [question, highlightText]);

  return (
    <span className="helpTopicSearchResultLabel">
      {headingMarkup}
      {summaryMarkup}
    </span>
  );
};

HelpTopicSearchResultLabel.propTypes = {
  topicDetail: FaqsQuestionPropTypes,
  highlightText: PropTypes.string
};
